import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Form, ListItem, Text,
} from '@domain-group/suit-theme'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

interface ChangeProps {
  fieldKey: string,
  values: any[] | object,
}

const isObject = (value: any) => typeof value === 'object' && !Array.isArray(value) && value !== null

const formatValue = (value: any) => {
  if (typeof value === 'boolean') return value.toString()
  if (!value) return 'null'
  if (isObject(value)) return JSON.stringify(value, null, 4)
  if (Array.isArray(value)) return JSON.stringify(value, null, 4)
  return value
}

const Change = (props: ChangeProps) => {
  const { fieldKey, values } = props

  const [initialValue, updatedValue] = Array.isArray(values) ? values : Object.values(values)

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed', marginTop: 'large', paddingBottom: 'large' }}
      disableHover
    >
      <Form.Field label={snakeToTitleCase(fieldKey)}>
        <Box alignItems="center" fontSize="small">
          <Text variant="ellipsis">{formatValue(initialValue)}&nbsp;</Text>

          <Box as="span" color="bodyFontLightColor" width="fit-content">
            <FontAwesomeIcon icon={faArrowRight} />
          </Box>

          <Text variant="ellipsis">&nbsp;{formatValue(updatedValue)}</Text>
        </Box>
      </Form.Field>
    </ListItem>
  )
}

export default Change
